import React from 'react';
import { Typography, Stack } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';
import { PayerEditor, ProductEditor, EffectiveDateEditor, EndDateEditor, FinancialClassEditor, CalcTypeEditor, FacilityTypeEditor, StatusEditor } from '../../fieldEditors/contractEditors';

const ContractOverview: React.FC = () => {
  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Contract Overview
      </Typography>
      
      <Stack spacing={3}>
        {/* Top Row: Payer and Product */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <PayerEditor />
          <ProductEditor />
        </Stack>

        {/* Second Row: Dates and Classifications */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <EffectiveDateEditor />
          <EndDateEditor />
          <FinancialClassEditor />
          <CalcTypeEditor />
          <FacilityTypeEditor />
          <StatusEditor />
        </Stack>
      </Stack>
    </SectionPaper>
  );
};

export default ContractOverview;
